import { Button } from '@cian/button-component';
import * as React from 'react';

import { EAddFeedbackStatus } from '../../../../actions/feedback';
import { trackSubmitButtonClick } from '../../../tracking';
import * as styles from '../CommentForm/styles/styles.css';

interface ISubmitButtonProps {
  formStatus: EAddFeedbackStatus;
  onClick(): void;
}

export function SubmitButton({ onClick, formStatus }: ISubmitButtonProps) {
  const handleClick = () => {
    if (formStatus === EAddFeedbackStatus.Succeed) {
      trackSubmitButtonClick();
    }

    onClick();
  };

  return (
    <div className={styles['submit_button']}>
      <Button theme="default" onClick={handleClick} isSync={formStatus === EAddFeedbackStatus.Loading}>
        Отправить
      </Button>
    </div>
  );
}
